import React, { Fragment, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
import store from "store";
import tabCfgAry from "./tabCfgAry";

import XtSvg from "components/xt/svg";

import CMPT_Zone from "./zone";
import CMPT_Group from "./group";

import styles from "./index.module.scss";

export interface TabCfgProps {
  key: string;
  label?: string;
  labelKey?: string;
  buyCoinAry?: string[];
  group?: string;
  plateId?: number;
  noHidden?: boolean;
}

interface Props {
  tabCfg: TabCfgProps;
  tabChange: (item: TabCfgProps) => void;
}

const Main: React.FC<Props> = ({ tabCfg, tabChange }) => {
  const t = useTranslation();
  const { isLogin } = store.user;
  const router = useRouter();

  // 检测当前是否在 CFD 页面
  const isCfd = useMemo(() => {
    return router.pathname?.startsWith("/cfd/") || router.asPath?.startsWith("/cfd/");
  }, [router.pathname, router.asPath]);

  // 检测当前是否是法币本位合约
  const isFiatContract = useMemo(() => {
    if (!isCfd) return false;
    const { name } = store.market;
    if (!name) return false;
    const quoteCurrency = name.split("_")[1]?.toUpperCase();
    const fiatCurrencies = ["AED", "BRL", "SAR"];
    return fiatCurrencies.includes(quoteCurrency);
  }, [isCfd, store.market.name]);

  const tabCfgAryFormat = useMemo(() => {
    const ary: any = [],
      doc = {};

    let filteredTabCfgAry: typeof tabCfgAry;

    if (!isCfd) {
      // 如果不是 CFD 页面，过滤掉法币 tab (fiat)
      filteredTabCfgAry = tabCfgAry.filter((obj) => obj.key !== "fiat");
    } else if (isFiatContract) {
      // 法币本位合约：一个 Crypto 法币 tab + 收藏 + stock + commodities（不再区分 AED/BRL/SAR）
      filteredTabCfgAry = tabCfgAry.filter(
        (obj) =>
          obj.key === "user" ||
          obj.key === "fiat" ||
          obj.key === "stocks" ||
          obj.key === "commodities"
      );
    } else {
      // U 本位 market 弹窗：crypto(usds) + 收藏 + stock + commodities
      filteredTabCfgAry = tabCfgAry.filter(
        (obj) =>
          obj.key === "user" ||
          obj.key === "usds" ||
          obj.key === "stocks" ||
          obj.key === "commodities"
      );
    }

    filteredTabCfgAry.map((obj) => {
      const { group } = obj;
      if (!group) return ary.push(obj);
      if (!doc[group]) {
        doc[group] = {
          group,
          children: [],
        };
        ary.push(doc[group]);
      }
      doc[group].children.push(obj);
    });

    return ary;
  }, [isCfd, isFiatContract]);

  return (
    <div className={styles.main}>
      {tabCfgAryFormat.map((item) => {
        if (item.key === "user") {
          if (isLogin) {
            return (
              <button key={item.key} className={cx("btnTxt", styles.user, { [styles.atv]: tabCfg.key === "user" })} onClick={() => tabChange(item)}>
                <XtSvg icon={`star-new-filled`} />
              </button>
            );
          } else {
            return <Fragment key={item.key}></Fragment>;
          }
        }

        if (item.group)
          return (
            <CMPT_Group key={item.group} tabCfg={tabCfg} groupCfg={item} tabChange={tabChange} className={cx({ [styles.atv]: tabCfg.group === item.group })} />
          );
        if (item.key === "zone")
          return <CMPT_Zone key={item.key} tabCfg={tabCfg} tabChange={tabChange} className={cx({ [styles.atv]: tabCfg.key === "zone" })} />;

        return (
          <button key={item.key} className={cx("btnTxt", { [styles.atv]: tabCfg.key === item.key })} onClick={() => tabChange(item)}>
            {item.labelKey ? t(item.labelKey) : item.label}
          </button>
        );
      })}
    </div>
  );
};

export default observer(Main);
// export default Main;
